import React, { useContext } from 'react';
import FigureCard from './FigureCard';
import { SystemSettingsContext } from '../../../../contexts/SystemSettingsContext';

const BreakdownFiguresA = ({ order = {}, performanceStats = [], deliveryStats }) => {
    const { formatNumber } = useContext(SystemSettingsContext);
    const roundedNumber = (v) => {
        return formatNumber(Math.round(v, 0));
    };
    return (
        <div>
            <div style={{ display: 'flex', width: '100%', columnGap: 11 }}>
                <FigureCard
                    title={"Total Delivered ('000)"}
                    figure={roundedNumber(deliveryStats?.deliveredImpacts)}
                    metric='impacts'
                />

                <FigureCard
                    title={"Total Booked ('000)"}
                    figure={roundedNumber(deliveryStats?.bookedImpacts)}
                    metric='impacts'
                />

                <FigureCard
                    title='Estimated Completion (Tracking)'
                    figure={roundedNumber((deliveryStats?.scheduledImpacts / deliveryStats?.bookedImpacts) * 100)}
                    metric='%'
                />
            </div>
        </div>
    );
};

export default BreakdownFiguresA;
